var exports = {
  "VA": "xe533113f--058c23--subtitle",
  "nf": "xe533113f--058c23--link",
};

module.exports = exports;
